import { render, staticRenderFns } from "./updateMedicalOrder.vue?vue&type=template&id=059fe6da&scoped=true&"
import script from "./updateMedicalOrder.vue?vue&type=script&lang=js&"
export * from "./updateMedicalOrder.vue?vue&type=script&lang=js&"
import style0 from "./updateMedicalOrder.vue?vue&type=style&index=0&id=059fe6da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059fe6da",
  null
  
)

export default component.exports